import {
  LearningObjectTypeEnum,
  StatusEnum,
} from '@plugins/octacornerstone-lib/enums';
import { LearningObject } from '@plugins/octacornerstone-lib/types';

import { dayInMs } from '../constants/constants';
import { getLearningObjectType } from '../constants/training-types-map';
import { getTrainingMinutes } from '../utils/get-training-minutes';

import { TrainingChild } from './training-child';

export class Training implements LearningObject {
  userId: string;
  externalId: string;
  userGuid: string;
  learningObjectId: string;
  learningTitle: string;
  registrationNumber: number;
  trainingType: string;
  providerName: string;
  trainingVersion: string;
  trainingPurpose: string;
  assignedDate: string;
  registrationDate: string;
  startDate: string;
  endDate: string;
  lastModifiedDate: string;
  dueDate: string;
  completedDate: string;
  status: string;
  statusGroup: string;
  isRemoved: boolean;
  isArchived: boolean;
  isRequired: boolean;
  children?: TrainingChild[];

  constructor(data: LearningObject) {
    Object.assign(this, data);
    this.children = data.children?.map((c) => new TrainingChild(c));
  }

  get pastDue(): boolean {
    return (
      this.statusGroup !== StatusEnum.COMPLETED &&
      this.dueDate &&
      new Date(this.dueDate) < new Date(Date.now() + dayInMs)
    );
  }

  get learningType() {
    return getLearningObjectType(this.trainingType);
  }

  get time(): string | null {
    const totalMinutes = this.totalMinutes();
    if (totalMinutes === null) {
      return null;
    }

    return totalMinutes >= 60
      ? Math.floor(totalMinutes / 60) + ' h ' + (totalMinutes % 60) + ' min'
      : totalMinutes + ' min';
  }

  get completionPercentage() {
    const totalMinutes = this.totalMinutes();
    if (totalMinutes === null) {
      return null;
    }

    const completedMinutes =
      this.children?.reduce(
        (acc, child) =>
          acc +
          (child.status === StatusEnum.COMPLETED
            ? getTrainingMinutes(child.loTrainingHours)
            : 0),
        0,
      ) ?? 0;

    return Math.round((completedMinutes / totalMinutes) * 100);
  }

  get isCurriculum() {
    return this.trainingType === LearningObjectTypeEnum.CURRICULUM;
  }

  get isCompleted() {
    return this.statusGroup === StatusEnum.COMPLETED;
  }

  get isInProgress() {
    return this.statusGroup === StatusEnum.IN_PROGRESS;
  }

  private totalMinutes = () => {
    const children = this.children;
    if (!children?.length) {
      return null;
    }
    const result = children.reduce(
      (acc, child) => acc + getTrainingMinutes(child.loTrainingHours),
      0,
    );
    return result >= 0 ? result : null;
  };
}
